import { isUpiIntentsFlowEnabled } from '../../../utils/mf-execution/upiIntentsFeature'
import { BuyPaymentMethodsButtonLegacy } from './BuyPaymentMethodsButton.legacy'
import { BuyPaymentMethodsButtonUpiIntents } from './BuyPaymentMethodsButton.upiIntents'
import { BuyPaymentMethodsButtonProps } from './buyPaymentMethodsButton.types'

export type {
  BuyPaymentMethodsButtonBaseProps,
  BuyPaymentMethodsButtonLegacyProps,
  BuyPaymentMethodsButtonUpiIntentsProps,
  BuyPaymentMethodsButtonProps,
} from './buyPaymentMethodsButton.types'

export { getPaymentMethodPrimaryLabel } from './BuyPaymentMethodsButton.upiIntents'

export const BuyPaymentMethodsButton = (props: BuyPaymentMethodsButtonProps) => {
  if (isUpiIntentsFlowEnabled()) {
    return (
      <BuyPaymentMethodsButtonUpiIntents
        amount={props.amount}
        isDisabled={props.isDisabled}
        handlePayNowClick={props.handlePayNowClick}
        selectedPaymentMethod={props.selectedPaymentMethod}
        handlePaymentMethodChange={props.handlePaymentMethodChange}
        paymentMethods={props.paymentMethods}
        paymentType={props.paymentType}
        trackingFund={props.trackingFund}
        installedUpiApps={props.installedUpiApps ?? null}
        bankAccountDetails={props.bankAccountDetails}
        defaultPaymentMethodDetails={props.defaultPaymentMethodDetails}
        requestUpiIntents={props.requestUpiIntents ?? (() => {})}
        upiIntentMaximumAllowedAmount={props.upiIntentMaximumAllowedAmount ?? 0}
      />
    )
  }

  return (
    <BuyPaymentMethodsButtonLegacy
      amount={props.amount}
      isDisabled={props.isDisabled}
      handlePayNowClick={props.handlePayNowClick}
      selectedPaymentMethod={props.selectedPaymentMethod}
      handlePaymentMethodChange={props.handlePaymentMethodChange}
      paymentMethods={props.paymentMethods}
      paymentType={props.paymentType}
      trackingFund={props.trackingFund}
      handleAddUPIClick={props.handleAddUPIClick ?? (() => {})}
    />
  )
}
